
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.5 19H3.49998C2.94998 19 2.49998 19.45 2.49998 20C2.49998 20.55 2.94998 21 3.49998 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.63997C21.85 8.83997 21.03 8.36997 20.23 8.57997L14.92 9.99997L8.45998 3.97997C8.18998 3.71997 7.79998 3.62997 7.43998 3.72997C6.75998 3.91997 6.43998 4.69997 6.78998 5.30997L10.23 11.27L5.25998 12.6L3.68998 11.36C3.43998 11.17 3.11998 11.1 2.80998 11.18L2.47998 11.27C2.15998 11.35 2.00998 11.72 2.17998 12L4.05998 15.25C4.28998 15.64 4.74998 15.83 5.17998 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.63997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-flight-takeoff`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFlightTakeoff

    ```js
    <b-new-b-icon-flight-takeoff />
    ```
</docs>


